import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { styled, useTheme } from 'styled-components';
import { Media } from '../../theme/Media';
import { Container } from '../../V2/Components/Container';
import Nav from './Nav';
import NavItem from './NavItem';
const CustomContainer = styled(Container) `
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media ${Media.xsMax} {
    flex-direction: column;
  }
  > *:not(:first-child) {
    @media ${Media.xsMax} {
      width: 100%;
      margin: 15px 0;
    }
  }
`;
const Wrapper = styled.div `
  background: ${({ $bgColor }) => $bgColor};
  min-height: 54px;
  display: flex;
  justify-content: flex-start;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
const SubHeaderComponent = ({ children, fluid = false, bgColor }) => {
    const theme = useTheme();
    const hasNoChildren = React.useMemo(() => !React.Children.map(children, (c) => c)?.some((c) => !!c), [children]);
    if (hasNoChildren) {
        return null;
    }
    return (_jsx(Wrapper, { "$bgColor": bgColor ?? theme.colors.grey00_1, children: _jsx(CustomContainer, { fluid: fluid, "data-testid": 'subheader-field', children: children }) }));
};
const SubHeaderMemo = React.memo(SubHeaderComponent);
const SubHeader = Object.assign(SubHeaderMemo, {
    Nav,
    NavItem,
});
export default SubHeader;
